import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import AdminSidePanel from "../components/AdminSidePanel";
import { Link } from "react-router-dom";
import "./Admin.css";
import "./Analytics.css";

const baseURL = process.env.REACT_APP_API_URL;


const AnalyticsPage = () => {
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(false);

    const [sidePanelOpen, setSidePanelOpen] = useState(false);
    const [sortByLikes, setSortByLikes] = useState("");

    const fetchRecipes = async () => {
        try{
            setLoading(true);
            const res = await fetch(`${baseURL}/recipes`);
            const data = await res.json();
            setRecipes(data);
        } catch (err) {
            console.error('Failed to fetch recipes:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecipes();
    }, []);

    const handleSortByLikesChange = (e) => {
        setSortByLikes(e.target.value);
    };

    const filterByDateRange = (recipes, sortBy) => {
        if(sortBy === "" || sortBy === "All Time") return recipes;

        const now = new Date();

        let cutoffDate;
        if (sortBy === "Monthly") {
            cutoffDate = new Date();
            cutoffDate.setMonth(now.getMonth() - 1);
        } else if (sortBy === "Weekly") {
            cutoffDate = new Date();
            cutoffDate.setDate(now.getDate() - 7);
        }

        return recipes.filter(recipe => {
            const recipeDate = new Date(recipe.createdAt);
            return recipeDate >= cutoffDate;
        });
    };

    const filteredRecipesByLikes = filterByDateRange(recipes, sortByLikes);
    const sortedRecipesByLikes = sortByLikes === "" ? filteredRecipesByLikes
        : [...filteredRecipesByLikes].sort((a, b) => b.likes - a.likes);

    return (
        <div>
            <Header />

            <div style={{ padding: '20px 20px 0' }}>
                <button
                onClick={() => setSidePanelOpen(true)}
                style={{
                    padding: '8px 12px',
                    fontSize: '16px',
                    backgroundColor: '#F4A261',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#5E503F'
                }}
                >
                ☰ Menu
                </button>
            </div>

            {sidePanelOpen && (
                <div className="overlay" onClick={() => setSidePanelOpen(false)} />
            )}

            <div className={`sidePanel ${sidePanelOpen ? 'open' : ''}`}>
                <button
                onClick={() => setSidePanelOpen(false)}
                style={{
                    marginLeft: '12px',
                    marginBottom: '20px',
                    fontSize: '18px',
                    background: 'none',
                    border: 'none',
                    color: '#5E503F',
                    cursor: 'pointer'
                }}
                >
                ✖ Close
                </button>
                <AdminSidePanel />
            </div>

            <div className="analytics-block">
                <div className="analytics-header">
                    <h2>Most Liked Recipes</h2>
                    <select value={sortByLikes} onChange={handleSortByLikesChange}>
                        <option value="" disabled hidden>Sort By</option>
                        <option>All Time</option>
                        <option>Monthly</option>
                        <option>Weekly</option>
                    </select>
                </div>
                <ol>
                    {sortedRecipesByLikes.map((r, i) => (
                        <li key={r._id || i}>
                            <a href={`/recipe/${r._id}`}>{r.title || r.name}</a>
                            <span className="stat">Likes: {r.likes || 0}</span>
                        </li>
                    ))}
                </ol>
            </div>

        </div>
    );
};
export default AnalyticsPage;